<template>
    <v-app>
        <v-main>
            <v-container
                    fill-height
                    fluid
            >
                <v-row
                        align="center"
                        justify="center"
                        no-gutters
                >
                    <v-col sm="4">
                        <v-img
                                :src="require('./assets/pear.png')"
                                max-width="128px"
                                class="mb-6"
                        />

                        <v-text-field
                                v-model="code"
                                solo
                                placeholder="enter code"
                                maxlength="5"
                                class="ma-4"
                                :disabled="loading"
                        >
                            <template v-slot:append>
                                <v-progress-circular
                                        v-if="loading"
                                        :size="20"
                                        width="2"
                                        indeterminate
                                ></v-progress-circular>
                            </template>
                        </v-text-field>
                        <div
                                class="text-center"
                                id="phrase"
                                v-html="phrase"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>

    import {words} from "./service/api";
    // import axios from 'axios';

    export default {
        name: 'App',

        components: {},

        data: () => ({
            code: '',
            loading: false,
        }),
        computed: {
            phrase() {
                return this.code.split('').map(letter => {
                    return words[letter]
                }).join(' ')
            }
        },
        watch: {
            code(newVal) {
                if (5 === newVal.length) {
                    this.loading = true
                    document.location.href = 'https://app.peardeck.com/join?utm_source=joinp.com&utm_medium=web&utm_campaign=buymydomain&code=' + newVal
                    // axios
                    //     .get('https://us-central1-joinp-ee683.cloudfunctions.net/addMessage?text=' + newVal)
                    //     .then(() => {
                    //         this.$analytics.logEvent('code_sent', { code: newVal})
                    //         document.location.href = 'https://app.peardeck.com/join?utm_source=joinp.com&utm_medium=web&utm_campaign=buymydomain&code=' + newVal
                    //     })
                } else {
                    this.loading = false
                }
            }
        },
    };
</script>
<style scoped lang="scss">
    .theme--light.v-application {
        background-color: #374141;
        font-family: Montserrat, sans-serif;

        .v-image {
            margin: auto;
        }

        .v-input {
            input {
                font-family: Montserrat, sans-serif;
                font-weight: 500;
                font-style: normal;
                color: #7a9494;
            }
        }

        #phrase {
            height: 64px;
            color: #d3d546;
        }
    }
</style>
